/* eslint-disable @typescript-eslint/default-param-last */
import { SHOW_LOADER, HIDE_LOADER } from '../constants/ActionTypes';
import initialState from '../store/initialState';
import { ILoaderAction } from '../types/loader.types';

const loaderReducer = (state = initialState.loader, action: ILoaderAction) => {
  switch (action.type) {
    case SHOW_LOADER:
      return {
        ...state,
        ...action.payload,
      };
    case HIDE_LOADER:
      return {
        show: false,
        message: null,
      };
    default:
      return state;
  }
};

export default loaderReducer;
